import React from 'react';
import * as Yup from 'yup';
import { withFormik } from 'formik';
import { pure, compose } from 'react-recompose';
// components
import { PopperComponent } from '../popper';
// helpers/constants
import * as G from '../../helpers';
// forms
import { Fieldset2 } from '../../forms';
// ui
import { Box, Flex, ModalActionButton } from '../../ui';
// utilities
import endpointsMap from '../../utilities/endpoints';
// component file-download
import { withAsyncDownload } from './with-async-download';
/////////////////////////////////////////////////////////////////////////////////////////

const enhance = compose(
  withAsyncDownload,
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: (props) => G.setInitialFormikValues(
      props.defaultFields,
      props.initialValues,
      props.searchedValues,
    ),
    validationSchema: (props) => Yup.object().shape(props.validationSchema),
    handleSubmit: ({ type }, { props, resetForm }) => {
      const { downloadOptions, handleAsyncDownloadFile } = props;

      const endpoint = G.getPropFromObject(downloadOptions.endpointName, endpointsMap);

      const data = {
        ...downloadOptions,
        endpoint,
        fileType: type,
      };

      handleAsyncDownloadFile(data);

      resetForm();
    },
    displayName: 'DOWNLOAD_DOC_FORM',
  }),
  pure,
);

const Content = (props) => (
  <Box p={15}>
    <form onSubmit={props.handleSubmit}>
      <Fieldset2 {...props} />
      <ModalActionButton mt={15} width='100%' type='submit' fontSize='16px'>
        {props.btnText}
      </ModalActionButton>
    </form>
  </Box>
);

export const FileDownload = enhance((props) => {
  const {
    icon,
    text,
    fields,
    handleAsyncDownloadFile,
  } = props;

  if (G.isNotNilAndNotEmpty(fields)) {
    return (
      <PopperComponent
        zi={21}
        type='click'
        position='bottom'
        content={<Content {...props} />}
      >
        <Flex>
          {
            G.isNotNilAndNotEmpty(text) &&
            <Box>{text}</Box>
          }
          <Box ml={15}>{icon}</Box>
        </Flex>
      </PopperComponent>
    );
  }
  return (
    <Box cursor='pointer' onClick={() => handleAsyncDownloadFile()}>
      <Flex>
        {
          G.isNotNilAndNotEmpty(text) &&
          <Box>{text}</Box>
        }
        <Box ml={30}>{icon}</Box>
      </Flex>
    </Box>
  );
});
